import { render, staticRenderFns } from "./photoSwipe.vue?vue&type=template&id=5676df7a&name=photoSwipe&"
import script from "./photoSwipe.vue?vue&type=script&lang=js&"
export * from "./photoSwipe.vue?vue&type=script&lang=js&"
import style0 from "./photoSwipe.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports